import React from 'react';
import { AlertTriangle } from 'lucide-react';

export const ImportInstructionsCard = () => {
  return (
    <div className="bg-muted rounded-lg p-4 border flex items-start gap-3">
      <AlertTriangle className="w-5 h-5 text-warning mt-1" />
      <div>
        <span className="font-semibold">Detección de Duplicados:</span>
        <ul className="list-disc ml-5 text-sm mt-1 text-muted-foreground">
          <li>El sistema busca automáticamente alumnos con nombre y apellidos similares.</li>
          <li>También verifica emails duplicados si se proporcionan.</li>
          <li>Los duplicados se marcarán y no se importarán.</li>
          <li>Puedes revisar la información de coincidencias en la previsualización.</li>
          <li>Solo se importarán los alumnos que no tengan conflictos.</li>
        </ul>
      </div>
    </div>
  );
};